module.exports = __webpack_public_path__ + "media/images/new/ad_free_experience@2x-32dfb1c8cbd33a82a19981853f943dd1.jpg";